import { render, staticRenderFns } from "./EditAprovacao.vue?vue&type=template&id=0a61e6ea"
import script from "./EditAprovacao.vue?vue&type=script&lang=js"
export * from "./EditAprovacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports